import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _LatestTopicListItem;
import Component from "@glimmer/component";
import { concat, hash } from "@ember/helper";
import { service } from "@ember/service";
import PluginOutlet from "discourse/components/plugin-outlet";
import PostsCountColumn from "discourse/components/topic-list/posts-count-column";
import TopicPostBadges from "discourse/components/topic-post-badges";
import TopicStatus from "discourse/components/topic-status";
import UserAvatarFlair from "discourse/components/user-avatar-flair";
import UserLink from "discourse/components/user-link";
import avatar from "discourse/helpers/avatar";
import categoryLink from "discourse/helpers/category-link";
import concatClass from "discourse/helpers/concat-class";
import discourseTags from "discourse/helpers/discourse-tags";
import formatDate from "discourse/helpers/format-date";
import topicFeaturedLink from "discourse/helpers/topic-featured-link";
import topicLink from "discourse/helpers/topic-link";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let LatestTopicListItem = (_class = (_LatestTopicListItem = class LatestTopicListItem extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "appEvents", _descriptor, this);
  }
  get tagClassNames() {
    if (this.args.topic.tags) {
      return this.args.topic.tags.map(tagName1 => `tag-${tagName1}`);
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <div
      data-topic-id={{@topic.id}}
      class={{concatClass
        "latest-topic-list-item"
        this.tagClassNames
        (if @topic.category (concat "category-" @topic.category.fullSlug))
        (if @topic.liked "liked")
        (if @topic.archived "archived")
        (if @topic.bookmarked "bookmarked")
        (if @topic.pinned "pinned")
        (if @topic.closed "closed")
        (if @topic.visited "visited")
      }}
    >
      <PluginOutlet
        @name="above-latest-topic-list-item"
        @connectorTagName="div"
        @outletArgs={{hash topic=@topic}}
      />

      <div class="topic-poster">
        <UserLink @user={{@topic.lastPosterUser}}>
          {{avatar @topic.lastPosterUser imageSize="large"}}
        </UserLink>
        <UserAvatarFlair @user={{@topic.lastPosterUser}} />
      </div>

      <div class="main-link">
        <div class="top-row">
          <TopicStatus @topic={{@topic}} />

          {{topicLink @topic}}
          {{~#if @topic.featured_link}}
            &nbsp;{{topicFeaturedLink @topic}}
          {{/if~}}
          <TopicPostBadges
            @unreadPosts={{@topic.unread_posts}}
            @unseen={{@topic.unseen}}
            @url={{@topic.lastUnreadUrl}}
          />
        </div>

        <div class="bottom-row">
          {{categoryLink @topic.category~}}
          {{~discourseTags @topic mode="list"}}
        </div>
      </div>

      <div class="topic-stats">
        <PluginOutlet
          @name="above-latest-topic-list-item-post-count"
          @connectorTagName="div"
          @outletArgs={{hash topic=@topic}}
        />

        <PostsCountColumn @topic={{@topic}} @tagName="div" />

        <div class="topic-last-activity">
          <a
            href={{@topic.lastPostUrl}}
            title={{@topic.bumpedAtTitle}}
          >{{formatDate @topic.bumpedAt format="tiny" noTitle="true"}}</a>
        </div>
      </div>
    </div>
  
*/
{
  "id": "5YZnhCQi",
  "block": "[[[1,\"\\n    \"],[10,0],[15,\"data-topic-id\",[30,1,[\"id\"]]],[15,0,[28,[32,0],[\"latest-topic-list-item\",[30,0,[\"tagClassNames\"]],[52,[30,1,[\"category\"]],[28,[32,1],[\"category-\",[30,1,[\"category\",\"fullSlug\"]]],null]],[52,[30,1,[\"liked\"]],\"liked\"],[52,[30,1,[\"archived\"]],\"archived\"],[52,[30,1,[\"bookmarked\"]],\"bookmarked\"],[52,[30,1,[\"pinned\"]],\"pinned\"],[52,[30,1,[\"closed\"]],\"closed\"],[52,[30,1,[\"visited\"]],\"visited\"]],null]],[12],[1,\"\\n      \"],[8,[32,2],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"above-latest-topic-list-item\",\"div\",[28,[32,3],null,[[\"topic\"],[[30,1]]]]]],null],[1,\"\\n\\n      \"],[10,0],[14,0,\"topic-poster\"],[12],[1,\"\\n        \"],[8,[32,4],null,[[\"@user\"],[[30,1,[\"lastPosterUser\"]]]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[32,5],[[30,1,[\"lastPosterUser\"]]],[[\"imageSize\"],[\"large\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[32,6],null,[[\"@user\"],[[30,1,[\"lastPosterUser\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"main-link\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"top-row\"],[12],[1,\"\\n          \"],[8,[32,7],null,[[\"@topic\"],[[30,1]]],null],[1,\"\\n\\n          \"],[1,[28,[32,8],[[30,1]],null]],[41,[30,1,[\"featured_link\"]],[[[1,\"             \"],[1,[28,[32,9],[[30,1]],null]],[1,\"\\n\"]],[]],null],[8,[32,10],null,[[\"@unreadPosts\",\"@unseen\",\"@url\"],[[30,1,[\"unread_posts\"]],[30,1,[\"unseen\"]],[30,1,[\"lastUnreadUrl\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"bottom-row\"],[12],[1,\"\\n          \"],[1,[28,[32,11],[[30,1,[\"category\"]]],null]],[1,[28,[32,12],[[30,1]],[[\"mode\"],[\"list\"]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"topic-stats\"],[12],[1,\"\\n        \"],[8,[32,2],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"above-latest-topic-list-item-post-count\",\"div\",[28,[32,3],null,[[\"topic\"],[[30,1]]]]]],null],[1,\"\\n\\n        \"],[8,[32,13],null,[[\"@topic\",\"@tagName\"],[[30,1],\"div\"]],null],[1,\"\\n\\n        \"],[10,0],[14,0,\"topic-last-activity\"],[12],[1,\"\\n          \"],[10,3],[15,6,[30,1,[\"lastPostUrl\"]]],[15,\"title\",[30,1,[\"bumpedAtTitle\"]]],[12],[1,[28,[32,14],[[30,1,[\"bumpedAt\"]]],[[\"format\",\"noTitle\"],[\"tiny\",\"true\"]]]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[\"@topic\"],false,[\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/topic-list/latest-topic-list-item.js",
  "scope": () => [concatClass, concat, PluginOutlet, hash, UserLink, avatar, UserAvatarFlair, TopicStatus, topicLink, topicFeaturedLink, TopicPostBadges, categoryLink, discourseTags, PostsCountColumn, formatDate],
  "isStrictMode": true
}), _LatestTopicListItem), _LatestTopicListItem), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { LatestTopicListItem as default };